import { render, staticRenderFns } from "./EspacesPartages.vue?vue&type=template&id=4c1ad4df&scoped=true&"
import script from "./EspacesPartages.vue?vue&type=script&lang=ts&"
export * from "./EspacesPartages.vue?vue&type=script&lang=ts&"
import style0 from "./EspacesPartages.vue?vue&type=style&index=0&id=4c1ad4df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ad4df",
  null
  
)

export default component.exports